import React, { useEffect, useState } from "react";
import { TextField, Button, MenuItem, Card, Typography } from "@mui/material";
import { categoryApi } from "store/api";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CategoryClip from "./CategoryClip";
import Rating from "@mui/material/Rating";
import { addProductApi } from "store/api";
import Success from "components/Success";
import { useLocation, useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ProductForm = () => {
  const location = useLocation();
  const product = location.state?.product;
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(product?.categories);
  const [basicDetail, setBasicDetail] = useState({
    nameEn: product?.nameEn,
    nameUz: product?.nameUz,
    slug: product?.slug,
    productCode: "",
    price: product?.price,
    discountPrice: product?.discountPrice,
    rating: product?.rating,
  });
  // const [dimensions, setDimentions] = useState({
  //   weight: "",
  //   length: "",
  //   width: "",
  //   height: "",
  // });
  const productDimentionKey = ["width", "height", "length", "weight"];
  const productDescriptionKey = ["descriptionEn", "descriptionUz", "descriptionOrder"];
  const productCharacteristicKey = ["keyEn", "keyUz", "valueEn", "valueUz"];
  const productWarrantyKey = ["descriptionEn", "descriptionUz", "price"];
  const productVideoKey = ["video", "videoThumbnail"];
  const productColorsKey = ["colorCode", "inventory"];
  const [dimensions, setDimentions] = useState(
    Object.fromEntries(
      Object.entries(product?.productDimension).filter(([key]) => productDimentionKey.includes(key))
    )
  );
  // product?.productDimension?.map(obj =>
  //   Object.fromEntries(Object.entries(obj).filter(([key]) => productDimentionKey.includes(key)))
  // )
  const [productColors, setProductColors] = useState(
    product?.colors?.map(obj =>
      Object.fromEntries(Object.entries(obj).filter(([key]) => productColorsKey.includes(key)))
    )
  );
  const [productDescription, setProductDescription] = useState(
    product?.descriptions?.map(obj =>
      Object.fromEntries(Object.entries(obj).filter(([key]) => productDescriptionKey.includes(key)))
    )
  );
  const [productCharacteristic, setProductCharacteristic] = useState(
    product?.characteristics?.map(obj =>
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => productCharacteristicKey.includes(key))
      )
    )
  );
  const [productWarranty, setProductWarranty] = useState(
    product?.warranty?.map(obj =>
      Object.fromEntries(Object.entries(obj).filter(([key]) => productWarrantyKey.includes(key)))
    )
  );
  const [productVideo, setProductVideo] = useState(
    product?.videos?.map(obj =>
      Object.fromEntries(Object.entries(obj).filter(([key]) => productVideoKey.includes(key)))
    )
  );
  const getAllCategory = async () => {
    const response = await categoryApi();
    if (response?.success) {
      setCategories(response?.data);
    }
  };

  const handleChangeBasicDetail = e => {
    const { name, value } = e.target;
    setBasicDetail({ ...basicDetail, [name]: name == "rating" ? String(value) : value });
  };
  const handleChangeDimentions = e => {
    const { name, value } = e.target;
    setDimentions({ ...dimensions, [name]: value });
  };

  // Handle input change
  const handleChangeCharacteristic = (index, event) => {
    const { name, value } = event.target;
    const newProductCharacteristic = [...productCharacteristic];
    newProductCharacteristic[index][name] = value;
    setProductCharacteristic(newProductCharacteristic);
  };

  // Add new Characteristic
  const addCharacteristic = () => {
    setProductCharacteristic([
      ...productCharacteristic,
      { id: Date.now(), keyEn: "", keyUz: "", valueEn: "", valueUz: "" },
    ]);
  };

  // Remove a Characteristic
  const removeCharacteristic = id => {
    if (id != 1)
      setProductCharacteristic(
        productCharacteristic.filter(characteristic => characteristic.id !== id)
      );
  };

  // Handle input change
  const handleChangeDescription = (index, event) => {
    const { name, value } = event.target;
    const newProductDescription = [...productDescription];
    newProductDescription[index][name] = value;
    setProductDescription(newProductDescription);
  };

  // Add new Description
  const addDescription = () => {
    setProductDescription([
      ...productDescription,
      { id: Date.now(), descriptionEn: "", descriptionUz: "", descriptionOrder: 1 },
    ]);
  };

  // Remove a Description
  const removeDescription = id => {
    if (id != 1)
      setProductDescription(productDescription.filter(description => description.id !== id));
  };

  // Handle input change
  const handleChangeWarranty = (index, event) => {
    const { name, value } = event.target;
    const newProductWarranty = [...productWarranty];
    newProductWarranty[index][name] = value;
    setProductWarranty(newProductWarranty);
  };

  // Add new Warranty
  const addWarranty = () => {
    setProductWarranty([
      ...productWarranty,
      { id: Date.now(), descriptionEn: "", descriptionUz: "", price: "" },
    ]);
  };

  // Remove a Warranty
  const removeWarranty = id => {
    if (id != 1) setProductWarranty(productWarranty.filter(warranty => warranty.id !== id));
  };

  // Handle input change
  const handleChangeColor = (index, event) => {
    const { name, value } = event.target;
    const newColors = [...productColors];
    newColors[index][name] = value;
    setProductColors(newColors);
  };

  // Add new color
  const addColor = () => {
    setProductColors([...productColors, { id: Date.now(), color: "", hexCode: "" }]);
  };

  // Remove a color
  const removeColor = id => {
    if (id != 1) setProductColors(productColors.filter(color => color.id !== id));
  };

  // Handle input change
  const handleChangeVideo = (index, event) => {
    const { name, value } = event.target;
    const newProductVideo = [...productVideo];
    newProductVideo[index][name] = value;
    setProductVideo(newProductVideo);
  };

  // Add new Warranty
  const addVideo = () => {
    setProductVideo([...productVideo, { id: Date.now(), video: "", videoThumbnail: "" }]);
  };

  // Remove a Warranty
  const removeVideo = id => {
    if (id != 1) setProductVideo(productVideo.filter(video => video.id !== id));
  };

  const [error, setError] = useState();
  const [errorMsg, setErrorMsg] = useState();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!basicDetail?.rating) {
      setErrorMsg("Please select rating");
      setError(true);
    } else if (!selectedCategory?.length) {
      setErrorMsg("Please select minimum one category");
      setError(true);
    } else {
      const categoryData = selectedCategory.map(item => item.categoryId);
      const data = {
        basicDetail: basicDetail,
        colors: productColors,
        dimension: dimensions,
        description: productDescription,
        characteristic: productCharacteristic,
        category: categoryData,
      };
      if (productWarranty?.length) {
        data.warranty = productWarranty;
      }
      if (productVideo?.length) {
        data.videoDetails = productVideo;
      }
      const response = await addProductApi(data);
      if (response?.success) {
        setMsg("Product Add Successfully");
        setSuccess(true);
        setTimeout(() => {
          navigate("/product-details", {
            state: { productId: response?.data?.productDetails?.productId },
          });
        }, [2000]);
      } else {
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
      if (response?.response) {
        setSuccess(false);
        setMsg(response?.response?.data?.message);
      }
      setOpen(true);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
        <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
          <Typography variant='h6'>Product Basic Details</Typography>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name in English'
              name='nameEn'
              variant='outlined'
              margin='normal'
              value={basicDetail?.nameEn}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name in Ukrain'
              name='nameUz'
              variant='outlined'
              margin='normal'
              value={basicDetail?.nameUz}
              onChange={handleChangeBasicDetail}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Slug'
              name='slug'
              variant='outlined'
              margin='normal'
              value={basicDetail?.slug}
              style={{ width: "100%" }}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Product Code'
              name='productCode'
              variant='outlined'
              margin='normal'
              style={{ width: "67.5%" }}
              value={basicDetail?.productCode}
              onChange={handleChangeBasicDetail}
            />
            {/* <Typography component='legend'>Controlled</Typography>
            <Rating
              name='simple-controlled'
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            /> */}
            <TextField
              // required
              type='number'
              select
              inputProps={{ min: 1 }}
              fullWidth
              label='Product Rating'
              name='rating'
              variant='outlined'
              margin='normal'
              style={{ width: "30%" }}
              value={basicDetail.rating}
              onChange={handleChangeBasicDetail}
              className='rating-box'
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </TextField>
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='number'
              inputProps={{ min: 1 }}
              fullWidth
              label='Price'
              name='price'
              variant='outlined'
              margin='normal'
              style={{ width: "50%" }}
              value={basicDetail?.price}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='number'
              fullWidth
              inputProps={{ min: 1 }}
              label='Product Discount Price'
              name='discountPrice'
              variant='outlined'
              margin='normal'
              style={{ width: "47.5%" }}
              value={basicDetail?.discountPrice}
              onChange={handleChangeBasicDetail}
            />
            {/* <Typography variant='h6' style={{ marginTop: "20px" }}>
          Product Categories
        </Typography> */}
            {/* <TextField
              required
              type='text'
              select
              fullWidth
              multiple
              value={productCategory}
              label='Product Category'
              name='productCategory'
              variant='outlined'
              margin='normal'
              // value={formData.productCategory}
              onChange={(e)=>{handleChangeCategory(e.target.value)}}
            >
              {categories.map(category => (
                <MenuItem value={category?.categoryId}>
                  {category?.nameEn}
                </MenuItem>
              ))}
            </TextField> */}

            <CategoryClip
              categories={categories}
              selectedCategories={selectedCategory}
              setSelectedCategories={setSelectedCategory}
            />
            {/* <div>
              <strong>Selected Categories: </strong>
              {productCategory.join(", ")}
            </div> */}
          </div>
          {/* <TextField required
          type='text'
          fullWidth
          label='Trending'
          name='trending'
          variant='outlined'
          margin='normal'
          value={formData?.trending}
          onChange={handleChange}
        /> */}
          {/* <Typography variant='h6' style={{ marginTop: "20px" }}>
          Product Gallery
        </Typography>
        <div
          style={{
            border: "1px dashed #ccc",
            padding: "40px",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <Typography>Drop files here or click to upload</Typography>
        </div> */}
        </Card>

        <Card style={{ flex: 1, padding: "20px", minWidth: "50%" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Description
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addDescription}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {productDescription.map((description, index) => (
            <div
              key={description.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <TextField
                required
                type='text'
                fullWidth
                label='Description in English'
                name='descriptionEn'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                value={description.descriptionEn}
                onChange={e => handleChangeDescription(index, e)}
              />
              <TextField
                required
                type='text'
                fullWidth
                label='Description in Ukrain'
                name='descriptionUz'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                value={description.descriptionUz}
                onChange={e => handleChangeDescription(index, e)}
              />
              <TextField
                required
                type='number'
                inputProps={{ min: 1 }}
                fullWidth
                label='Order'
                name='descriptionOrder'
                variant='outlined'
                margin='normal'
                value={description.descriptionOrder}
                onChange={e => handleChangeDescription(index, e)}
              />
              {description.id != 1 && (
                <CloseRoundedIcon onClick={() => removeDescription(description.id)} />
              )}
              {/* <span onClick={() => removeColor(color.id)}>Remove</span> */}
            </div>
          ))}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Characteristic
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addCharacteristic}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {productCharacteristic.map((characteristic, index) => (
            <div
              key={characteristic.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <div>
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Characteristic Key in English'
                  name='keyEn'
                  variant='outlined'
                  multiline
                  maxRows={4}
                  margin='normal'
                  value={characteristic.keyEn}
                  onChange={e => handleChangeCharacteristic(index, e)}
                />
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Characteristic Value in English'
                  name='valueEn'
                  variant='outlined'
                  margin='normal'
                  multiline
                  maxRows={4}
                  value={characteristic.valueEn}
                  onChange={e => handleChangeCharacteristic(index, e)}
                />
              </div>
              <div>
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Characteristic Key in Ukrain'
                  name='keyUz'
                  variant='outlined'
                  margin='normal'
                  multiline
                  maxRows={4}
                  value={characteristic.keyUz}
                  onChange={e => handleChangeCharacteristic(index, e)}
                />
                <TextField
                  required
                  type='text'
                  fullWidth
                  label='Characteristic Value in Ukrain'
                  name='valueUz'
                  variant='outlined'
                  multiline
                  maxRows={4}
                  margin='normal'
                  value={characteristic.valueUz}
                  onChange={e => handleChangeCharacteristic(index, e)}
                />
              </div>
              {characteristic.id != 1 && (
                <CloseRoundedIcon onClick={() => removeCharacteristic(characteristic.id)} />
              )}
              {/* <span onClick={() => removeColor(color.id)}>Remove</span> */}
            </div>
          ))}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product colors
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addColor}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {productColors.map((color, index) => (
            <div
              key={color.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <TextField
                required
                type='color'
                fullWidth
                label='Color'
                name='colorCode'
                variant='outlined'
                margin='normal'
                value={color.colorCode}
                onChange={e => handleChangeColor(index, e)}
              />
              <TextField
                required
                type='number'
                inputProps={{ min: 0 }}
                fullWidth
                label='Inventory'
                name='inventory'
                variant='outlined'
                margin='normal'
                value={color.inventory}
                onChange={e => handleChangeColor(index, e)}
              />
              {color.id != 1 && <CloseRoundedIcon onClick={() => removeColor(color.id)} />}
              {/* <span onClick={() => removeColor(color.id)}>Remove</span> */}
            </div>
          ))}
        </Card>

        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography variant='h6'>Product Dimensions</Typography>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Weight(kg)'
              name='weight'
              variant='outlined'
              margin='normal'
              value={dimensions?.weight}
              onChange={handleChangeDimentions}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Width(cm)'
              name='width'
              variant='outlined'
              margin='normal'
              value={dimensions?.width}
              onChange={handleChangeDimentions}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Height(cm)'
              name='height'
              variant='outlined'
              margin='normal'
              value={dimensions?.height}
              onChange={handleChangeDimentions}
            />
            <TextField
              required
              type='text'
              fullWidth
              label='Length(cm)'
              name='length'
              variant='outlined'
              margin='normal'
              value={dimensions?.length}
              onChange={handleChangeDimentions}
            />
          </div>
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Warranty
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addWarranty}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {productWarranty.map((warranty, index) => (
            <div
              key={warranty.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <TextField
                // required
                type='text'
                fullWidth
                label='Warranty Description in English'
                name='descriptionEn'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                value={warranty.descriptionEn}
                onChange={e => handleChangeWarranty(index, e)}
              />
              <TextField
                // required
                type='text'
                fullWidth
                label='Warranty Description in Ukrain'
                name='descriptionUz'
                variant='outlined'
                margin='normal'
                multiline
                maxRows={4}
                value={warranty.descriptionUz}
                onChange={e => handleChangeWarranty(index, e)}
              />
              <TextField
                // required
                type='number'
                fullWidth
                inputProps={{ min: 0 }}
                label='Price'
                name='price'
                variant='outlined'
                margin='normal'
                value={warranty.price}
                onChange={e => handleChangeWarranty(index, e)}
              />
              {warranty.id != 1 && <CloseRoundedIcon onClick={() => removeWarranty(warranty.id)} />}
            </div>
          ))}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Video
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                cursor: "pointer",
              }}
              onClick={addVideo}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {productVideo.map((video, index) => (
            <div
              key={video.id}
              style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}
            >
              <TextField
                // required
                type='text'
                fullWidth
                label='Video link'
                name='video'
                variant='outlined'
                margin='normal'
                value={video.video}
                onChange={e => handleChangeVideo(index, e)}
              />
              <TextField
                // required
                type='text'
                fullWidth
                label='Video thumbnail link'
                name='videoThumbnail'
                variant='outlined'
                margin='normal'
                value={video.videoThumbnail}
                onChange={e => handleChangeVideo(index, e)}
              />
              {productVideo.id != 1 && <CloseRoundedIcon onClick={() => removeVideo(video.id)} />}
            </div>
          ))}
        </Card>

        {error && (
          <div
            style={{
              color: "red",
              fontSize: "16px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <InfoOutlinedIcon /> {errorMsg}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingTop: "20px",
            width: "100%",
          }}
        >
          <Button color='warning' variant='contained'>
            Cancel
          </Button>
          <Button variant='contained' color='success' type='submit'>
            Submit
          </Button>
        </div>
      </div>
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </form>
  );
};

export default ProductForm;
